<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates22">
<p class="centerImage"><img alt="images" id="plate22" src="images/plate22.jpg"/></p>
<p class="caption">VIPs at Richmond. At left is G/C A L Walters, then me; Mr A S Drakeford and Dr H Evatt are the two suits with Jimmy Wellsman between them. A/Cdr P G Heffernan OBE AFC is talking to Robin Norwood. On the far right is Sgt Peter McCarthy, who was killed on 5 February 1943.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates22.vue?8c891484